import WixExperiments from '@wix/wix-experiments';

export enum CrmHomeSpec {
  MadeforFont = 'specs.crm.CrmHomeMadeforFont',
}

export class Experiments {
  private readonly wixExperiments: WixExperiments = new WixExperiments({
    scope: 'business-manager',
  });

  async experimentsReady(): Promise<void> {
    await this.wixExperiments.ready();
  }

  isEnabled(spec: CrmHomeSpec) {
    return this.wixExperiments.enabled(spec);
  }
}

export async function createExperiments() {
  const experiments = new Experiments();
  await experiments.experimentsReady();
  return experiments;
}
